import { defineMessages } from 'react-intl'

const scope = `procurify.platform.organization-management.pages`

export default defineMessages({
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  managePrimaryCategoriesTitle: {
    id: `${scope}.managePrimaryCategoriesTitle`,
    defaultMessage:
      '{pluralPrimaryOrgCategoryLabel} & {pluralSecondaryOrgCategoryLabel}',
  },
  primaryCategoryDetailsTitle: {
    id: `${scope}.primaryCategoryDetailsTitle`,
    defaultMessage: '{singularPrimaryOrgCategoryLabel} details',
  },
})
